import { HighlightType } from './types';

export const toHighlightType = (type: string | undefined, isAdmin: boolean): HighlightType => {
  switch (type) {
    case 'highlight':
      return 'highlight';
    case 'clip':
      return 'clip';
    case 'behavior':
      return 'behavior';
    case 'curated':
      if (isAdmin) return 'curated'; // only admins can see curated highlights tab
    // fallthrough to default
    default:
      return 'highlight';
  }
};

export const isNew = (date: string | undefined) => {
  if (!date) return false;
  return Date.parse(date) > Date.now() - 1000 * 60 * 60 * 24;
};
